<template>
    <b-container fluid>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{$t('externalUser.event_list')}}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <div class="message-body-center">
                                <template>
                                    <b-overlay :show="loader">
                                        <b-row>
                                            <b-col>
                                            <b-table-simple class="tg mt-3" bordered hover small caption-top responsive>
                                                <b-thead>
                                                <b-tr>
                                                    <b-th style="width:10%" class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('globalTrans.fiscal_year') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.event_name') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.venue') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.start_date') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('externalUser.end_date') }}</b-th>
                                                    <b-th style="width:10%" class="text-center">{{ $t('globalTrans.status') }}</b-th>
                                                </b-tr>
                                                </b-thead>
                                                <slot v-for="(info, index) in datas.allEventList">
                                                    <b-tr :class='checkEventDate(info)' :key="index">
                                                        <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                                        <b-td class="text-center">{{ $n(info.fiscal_year_id, { useGrouping: false }) }}</b-td>
                                                        <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.event_info_bn : info.event_info }}</b-td>
                                                        <b-td class="text-center">{{ ($i18n.locale === 'bn') ? info.location_bn : info.location }}</b-td>
                                                        <b-td class="text-center">{{ info.start_date | dateFormat }}</b-td>
                                                        <b-td class="text-center">{{ info.end_date | dateFormat }}</b-td>
                                                        <b-td class="text-center" v-if="$i18n.locale === 'en'">{{ checkEventDate(info) ? 'Upcoming Event' : 'Closed Event'}}</b-td>
                                                        <b-td class="text-center" v-else>{{ checkEventDate(info) ? 'আসন্ন ইভেন্ট' : 'বন্ধ ইভেন্ট'}}</b-td>
                                                    </b-tr>
                                                </slot>
                                            </b-table-simple>
                                            </b-col>
                                        </b-row>
                                    </b-overlay>
                                </template>
                            </div>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
    import { dashboardPatientPanelApi } from '../../api/routes'
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        data () {
            return {
                loading: false,
                datas: [],
                serviceQuantity: 0,
                currentEvent: 0,
                serviceCategory: 0,
                totaService: 0,
                unitLoad: false,
                loader: false

            }
        },
        created () {
            this.getData()
        },
        computed: {
            ...mapGetters({
                panelObj: 'ExternalUser/panelObj'
            })
        },
        methods: {
            checkEventDate (data) {
                var compareDate = moment()
                var startDate = moment(data.start_date)
                var endDate = moment(data.end_date).add(1, 'days')
                const checkD = compareDate.isBetween(startDate, endDate)
                if (checkD) {
                    return 'blink'
                }
            },
            async getData () {
                this.unitLoad = true
                this.loader = true
                const result = await RestApi.getData(awarenessEventServiceBaseUrl, dashboardPatientPanelApi)
                if (result.success) {
                    this.datas = result.data
                } else {
                    this.datas = []
                }
                this.unitLoad = false
                this.loader = false
            }
        }
    }
</script>
<style>
@-webkit-keyframes blink {
    0% { background: rgb(255, 255, 0)}
    49%{ background: rgb(8, 128, 151)}
    60%{ background: rgb(255, 0, 0)}
    100% {
        background: rgb(8, 128, 151)
    }
}
@-moz-keyframes blink {
    0% { background: rgb(255, 255, 0)}
    49%{ background: rgb(8, 128, 151)}
    60%{ background: rgb(255, 0, 0)}
    100% {
        background: rgb(8, 128, 151)
    }
}
@keyframes blink {
    0% { background: rgb(255, 255, 0)}
    49%{ background: rgb(8, 128, 151)}
    60%{ background: rgb(255, 0, 0)}
    100% {
        background: rgb(8, 128, 151)
    }
}
.blink {
    -webkit-animation-direction: normal;
    -webkit-animation-duration: 5s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: blink;
    -webkit-animation-timing-function: linear;
    -moz-animation-direction: normal;
    -moz-animation-duration: 5s;
    -moz-animation-iteration-count: infinite;
    -moz-animation-name: blink;
    -moz-animation-timing-function: linear;
    animation-direction: normal;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-name: blink;
    animation-timing-function: linear;
}
</style>
